const getCourseList = state => state?.courses?.coursesList
const getStudentDegreeList = state => state?.courses?.degreeList

const selectors = {
  getCourseList,
  getStudentDegreeList
}

export default selectors